import { Observable } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.css']
})
export class ProductListComponent {

  paginMaxLength: number;
  pageSize: number;
  pageSizeOption: number [];

  @Input() category: string;
  public  products: Observable<any>;

  constructor(private dataService: DataService, private router: Router) {
    this.paginMaxLength = 0;
    this.pageSize = 10;
    this.pageSizeOption = [];
  }

  ngOnInit() {}

  ngOnChanges() {
    if (this.category) {
      this.products = this.dataService.newGetProductsByCategorySlug(this.category, this.paginMaxLength, this.pageSize);
      this.dataService.getProductCount(this.category).subscribe(
        data => {
          this.paginMaxLength = data;
          this.initPageSizeOption();
        }
      );
    }
  }

  pageChanged(event) {
    this.products = this.dataService.newGetProductsByCategorySlug(this.category, event.pageIndex * event.pageSize ,this.pageSize)
  }

  openProduct(product) {
    this.router.navigate(['product/' + product.id]);
  }

  initPageSizeOption() {
    const trunc = Math.trunc(this.paginMaxLength / this.pageSize);
    for (let i = 0; i < trunc; i++) {
      this.pageSizeOption.push(i * this.pageSize);
    }
  }

}
